// Global date-format utilities — enforces dd/mm/yyyy across the app.
// Use these instead of raw toLocaleDateString/toLocaleString so we stay consistent.

/** Formats an ISO date/string to "DD/MM/YYYY" (default) or supplied options. */
export function fmtDate(input, opts = {}) {
  if (!input) return '—';
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return String(input);
  const { withTime = false, monthName = false, weekday = false } = opts;
  if (monthName) {
    // e.g. "02 Feb 2026"
    return d.toLocaleDateString('en-GB', {
      day: '2-digit', month: 'short', year: 'numeric',
      ...(weekday ? { weekday: 'short' } : {}),
    });
  }
  const pad = (n) => String(n).padStart(2, '0');
  const dd = pad(d.getDate());
  const mm = pad(d.getMonth() + 1);
  const yyyy = d.getFullYear();
  if (withTime) return `${dd}/${mm}/${yyyy} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  return `${dd}/${mm}/${yyyy}`;
}

/** Short human date + time. Example: "02/12/2007 14:30" */
export function fmtDateTime(input) { return fmtDate(input, { withTime: true }); }

/** "02 Feb 2026" — for cards / headers where readability matters. */
export function fmtDateHuman(input) { return fmtDate(input, { monthName: true }); }

/** Relative "3 din pehle" / "2 hrs ago" style — cheap approximate. */
export function fmtRelative(input) {
  if (!input) return '—';
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return String(input);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return 'just now';
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 86400 * 30) return `${Math.floor(s / 86400)}d ago`;
  return fmtDateHuman(d);
}
